import React, { useState, useEffect, useRef } from "react"
import { navigate } from "gatsby"
import axios from "axios"
import { useFormik, FastField } from "formik"
import Modal from "react-bootstrap/Modal"
import { useToasts } from "react-toast-notifications"
import DatePicker from "react-datepicker"
import { sub, format } from "date-fns"

import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/main.css"

import "react-datepicker/dist/react-datepicker.css"

import FormError from "../../../formError"
import { object, string } from "prop-types"

const ShareholderModal = (props) => {
  const { addToast } = useToasts()
  const [message, setMessage] = useState("")
  const [state, setState] = useState({
    isButtonDisabled: false,
  })

  const [st, setSt] = useState([])
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState("")
  const [identityTypes, setIdentityTypes] = useState([])
  const signatureFileRef = useRef(null)
  const passportFileRef = useRef(null)
  const [fileWarrningText, setFileWarningText] = useState("")
   

  const handleClose = () => props.closePopup()

  const getStates = () => {
    fetch("https://apigateway.sparkleapp.in/api/v1/kyc/states")
      .then((response) => response.json())
      .then((data) => setSt(data.data))
  }

  const getCountries = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`)
      .then((response) => response.json())
      .then((data) => {
        setCountries(data)
      })
  }

  const getIdentities = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/IdentityTypes`)
      .then((response) => response.json())
      .then((data) => {
        setIdentityTypes(data)
      })
  }

  useEffect(() => {
    getStates()
    getCountries()
    getIdentities()
  }, [])

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      occupation: "",
      dob: "",
      gender: "",
      shareholder_type: "",
      shareholder_address: "",
      shareholder_state: "",
      shareholder_city: "",
      shareholder_email: "",
      shareholder_phone: "",
      no_of_shares: "",
      is_shareholder_director: "",
      nationality: "",
      registered_country: "",
      cac_certificate: "",
      shareholder_signature: "",
      shareholder_country: "",
      identity_type: "",
      identity_number: "",
      identity: "",
      signature: "",
    },
    onSubmit: async (values) => {
      const data = {
        firstname: values.firstname,
        lastname: values.lastname,
        occupation: values.occupation,
        dob: format(new Date(values.dob), "yyyy-MM-dd"),
        gender: values.gender,
        shareholder_type: values.shareholder_type,
        shareholder_address: values.shareholder_address,
        shareholder_state: values.shareholder_state,
        shareholder_city: values.shareholder_city,
        shareholder_email: values.shareholder_email,
        shareholder_phone: values.shareholder_phone,
        no_of_shares: values.no_of_shares,
        is_shareholder_director: values.is_shareholder_director,
        nationality: +values.shareholder_country,
        registered_country: values.registered_country,
        cac_certificate: values.cac_certificate,
        shareholder_signature: values.shareholder_signature,
        shareholder_country: +values.shareholder_country,
        identity_type: values.identity_type,
        identity_number: values.identity_number,
        identity: values.identity,
        signature: values.signature,
      }

      const existingData =
        JSON.parse(localStorage.getItem("formDataArray")) || []

      existingData.push(data)
      localStorage.setItem("formDataArray", JSON.stringify(existingData))
      handleClose()
      formik.resetForm()
      props.fetchShareholders()
    },
  })
  const clearFileInputs = () => {
    if (signatureFileRef.current) {
      signatureFileRef.current.value = ""
    }
    if (passportFileRef.current) {
      passportFileRef.current.value = ""
    }
  }
  const handleChange = (event) => {
    const { name, value } = event.target

    // Convert string to boolean
    const newValue = value === "true"

    // Use Formik's setFieldValue to update the form field
    formik.setFieldValue(name, newValue)
  }

  const uploadImage = (file_data, file_location) => {
    setLoading(true)
    const myHeaders = new Headers()
    myHeaders.append("Accept", "application/json")
    myHeaders.append("token", `${localStorage.getItem("mobile_token")}`)

    const data = new FormData()
    data.append("file", file_data, file_data.name)

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: data,
      redirect: "follow",
    }
    fetch(
      `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/document-upload`,
      requestOptions
    )
      .then((resp) => resp.json())
      .then((data) => {
        formik.setFieldValue(file_location, data.data.file)
        formik.setFieldValue(`${file_location}_name`, file_data.name)
        setLoading(false)
      })
      .catch((err) => {
         setLoading(false)
         addToast(err.response.data.message, {
           appearance: "error",
           placement: "top-center",
           autoDismiss: true,
         })
         if (err.response.data.message === "Token expired") {
           navigate("/business-support/get-started/")
         }
         clearFileInputs()
      })
  }

  const setFile = (file, location) => {
    const maxFileSize = 5 * 1024 * 1024 // 5MB in bytes

    if (file.size > maxFileSize) {
      setFileWarningText("File size should not exceed 5MB.")
      addToast("File size should not exceed 5MB", {
        appearance: "error",
        placement: "top-center",
        autoDismiss: true,
      })
      clearFileInputs()
      setTimeout(() => setFileWarningText(""), 2000)

      return
    }
    uploadImage(file, location)
  }

  return (
    <div>
      <Modal size="lg" show={props.show} onHide={props.closePopup} centered>
        <Modal.Body className="p-0 rounded-20 position-relative">
          <span
            aria-label="close"
            className="modal-close-btn"
            onClick={() => handleClose()}
            onKeyDown={() => handleClose()}
            role="button"
            tabIndex={0}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.41425 6.00001L11.7072 1.70701C12.0982 1.31601 12.0982 0.684006 11.7072 0.293006C11.3162 -0.0979941 10.6842 -0.0979941 10.2933 0.293006L6.00025 4.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L4.58625 6.00001L0.29325 10.293C-0.09775 10.684 -0.09775 11.316 0.29325 11.707C0.48825 11.902 0.74425 12 1.00025 12C1.25625 12 1.51225 11.902 1.70725 11.707L6.00025 7.41401L10.2933 11.707C10.4882 11.902 10.7443 12 11.0002 12C11.2562 12 11.5122 11.902 11.7072 11.707C12.0982 11.316 12.0982 10.684 11.7072 10.293L7.41425 6.00001Z"
                fill="black"
              ></path>
            </svg>
          </span>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h3 className="text-center font-weight-bold mt-5 sparkle--color__light">
                  Shareholders
                </h3>

                <p className="sparkle--color__light text-center mt-3">
                  Add shareholders to your proposed company
                </p>

                <p className="small mt-3 sparkle-bright-orange text-center">
                  {message}
                </p>

                <form
                  className="kwes-form waitlist__form my-lg-5 my-3"
                  onSubmit={formik.handleSubmit}
                >
                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_type">Shareholder Type</label>
                      <select
                        className="form-control custom-select"
                        id="shareholder_type"
                        name="shareholder_type"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_type}
                      >
                        <option value="">Select</option>
                        <option value="Individual">Individual</option>
                        <option value="Company">Company</option>
                      </select>

                      <FormError
                        touched={formik.touched.shareholder_type}
                        message={formik.errors.shareholder_type}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_type">Director?</label>
                      <select
                        className="form-control custom-select"
                        id="is_shareholder_director"
                        name="is_shareholder_director"
                        onChange={handleChange}
                        value={formik.values.is_shareholder_director}
                      >
                        <option value="">Select</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>

                      <FormError
                        touched={formik.touched.is_shareholder_director}
                        message={formik.errors.is_shareholder_director}
                      />
                    </div>
                  </div>
                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="firstname">First name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        name="firstname"
                        onChange={formik.handleChange}
                        value={formik.values.firstname}
                      />
                      <FormError
                        touched={formik.touched.firstname}
                        message={formik.errors.firstname}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="lastname">Last name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        name="lastname"
                        onChange={formik.handleChange}
                        value={formik.values.lastname}
                      />

                      <FormError
                        touched={formik.touched.lastname}
                        message={formik.errors.lastname}
                      />
                    </div>
                  </div>

                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_email">Email Address</label>
                      <input
                        type="text"
                        className="form-control"
                        id="shareholder_email"
                        name="shareholder_email"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_email}
                      />

                      <FormError
                        touched={formik.touched.shareholder_email}
                        message={formik.errors.shareholder_email}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_phone">Phone Number</label>

                      <IntlTelInput
                        inputClassName="form-control"
                        defaultCountry="ng"
                        id="shareholder_phone"
                        fieldName="shareholder_phone"
                        autoComplete="tel"
                        onPhoneNumberChange={(fullnumber, newNumber) => {
                          formik.setFieldValue("shareholder_phone", newNumber)
                        }}
                        value={formik.values.shareholder_phone}
                        placeholder="XXXX XXXX XXX"
                      />

                      <FormError
                        touched={formik.touched.shareholder_phone}
                        message={formik.errors.shareholder_phone}
                      />
                    </div>
                  </div>

                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="dob">Date of birth</label>

                      <DatePicker
                        selected={formik.values.dob}
                        onChange={(date) => formik.setFieldValue("dob", date)}
                        minDate={sub(new Date(), {
                          years: 500,
                        })}
                        maxDate={sub(new Date(), {
                          years: 18,
                        })}
                        placeholderText="Must be 18 years or older"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        type="date"
                        id="dob"
                        name="dob"
                        value={formik.values.dob}
                      />

                      <FormError
                        touched={formik.touched.dob}
                        message={formik.errors.dob}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="occupation">Occupation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="occupation"
                        name="occupation"
                        onChange={formik.handleChange}
                        value={formik.values.occupation}
                      />

                      <FormError
                        touched={formik.touched.occupation}
                        message={formik.errors.occupation}
                      />
                    </div>
                  </div>

                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_country">Country</label>
                      <select
                        className="form-control custom-select"
                        id="shareholder_country"
                        name="shareholder_country"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_country}
                      >
                        <option value="">Select Country</option>
                        {countries?.map((country) => (
                          <option key={country.value} value={country.value}>
                            {country.display}
                          </option>
                        ))}
                      </select>

                      <FormError
                        touched={formik.touched.shareholder_country}
                        message={formik.errors.shareholder_country}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="gender">Gender</label>
                      <select
                        type="text"
                        className="form-control custom-select"
                        id="gender"
                        name="gender"
                        onChange={formik.handleChange}
                        value={formik.values.gender}
                      >
                        <option value="" label="Select Gender">
                          Select Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>

                      <FormError
                        touched={formik.touched.gender}
                        message={formik.errors.gender}
                      />
                    </div>
                  </div>

                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_state	">State</label>
                      <select
                        className="form-control custom-select"
                        id="shareholder_state"
                        name="shareholder_state"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_state}
                      >
                        <option value="" label="Select State">
                          Select State
                        </option>
                        {st?.map((data) => (
                          <option key={data.id} value={data.name}>
                            {data.name}
                          </option>
                        ))}
                      </select>

                      <FormError
                        touched={formik.touched.shareholder_state}
                        message={formik.errors.shareholder_state}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="shareholder_city">City</label>
                      <input
                        type="text"
                        className="form-control"
                        id="shareholder_city"
                        name="shareholder_city"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_city}
                      />

                      <FormError
                        touched={formik.touched.shareholder_city}
                        message={formik.errors.shareholder_city}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="shareholder_address">
                        Business address
                      </label>
                      <input
                        className="form-control"
                        id="shareholder_address"
                        name="shareholder_address"
                        as="textarea"
                        rows="2"
                        onChange={formik.handleChange}
                        value={formik.values.shareholder_address}
                      />

                      <FormError
                        touched={formik.touched.shareholder_address}
                        message={formik.errors.shareholder_address}
                      />
                    </div>
                  </div>

                  <div className="form-row justify-between">
                    <div className="form-group col-md-5">
                      <label htmlFor="identity_type">Identity Type</label>
                      <select
                        className="form-control custom-select"
                        as="select"
                        id="identity_type"
                        name="identity_type"
                        onChange={formik.handleChange}
                        value={formik.values.identity_type}
                      >
                        <option value="">Select Type</option>
                        {identityTypes.map((identity) => (
                          <option key={identity.value} value={identity.value}>
                            {identity.display}
                          </option>
                        ))}
                      </select>

                      <FormError
                        touched={formik.touched.identity_type}
                        message={formik.errors.identity_type}
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label htmlFor="identity_number">Identity Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="identity_number"
                        name="identity_number"
                        onChange={formik.handleChange}
                        value={formik.values.identity_number}
                      />

                      <FormError
                        touched={formik.touched.identity_number}
                        message={formik.errors.identity_number}
                      />
                    </div>
                  </div>

                  {/* <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="identity_number">Identity Number</label>
                      <FastField
                        type="text"
                        className="form-control"
                        id="identity_number"
                        name="identity_number"
                      />

                      <FormError
                        touched={formik.touched.identity_number}
                        message={formik.errors.identity_number}
                      />
                    </div>
                  </div> */}

                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="identity">Upload Identity Document</label>
                      <input
                        type="file"
                        className="form-control border-0"
                        id="identity"
                        name="identity"
                        accept="application/pdf"
                        title="Accept pdf only"
                        ref={passportFileRef}
                        onChange={(e) => setFile(e.target.files[0], "identity")}
                      />

                      <label
                        htmlFor="identity"
                        className="font-weight-light text-muted"
                      >
                        pdf file only
                      </label>

                      <FormError
                        touched={formik.touched.identity}
                        message={formik.errors.identity}
                      />
                    </div>
                  </div>
                  <div
                    className={
                      loading
                        ? "progress_state form-row justify-content-center"
                        : "form-row justify-content-center"
                    }
                  >
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label htmlFor="signature">Upload signature</label>
                        <input
                          type="file"
                          className="form-control border-0"
                          id="signature"
                          name="signature"
                          ref={signatureFileRef}
                          onChange={(e) =>
                            setFile(e.target.files[0], "signature")
                          }
                        />

                        <label
                          htmlFor="signature"
                          className="font-weight-light text-muted"
                        >
                          pdf file only
                        </label>

                        <FormError
                          touched={formik.touched.signature}
                          message={formik.errors.signature}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-5">
                      <label htmlFor="no_of_shares">No of Shares</label>
                      <input
                        type="text"
                        className="form-control"
                        id="no_of_shares"
                        name="no_of_shares"
                        onChange={formik.handleChange}
                        value={formik.values.no_of_shares}
                      />

                      <FormError
                        touched={formik.touched.no_of_shares}
                        message={formik.errors.no_of_shares}
                      />
                    </div>
                  </div>
                  {fileWarrningText && (
                    <p className="sparkle--font__14 sparkle-bright-orange sparkle--weight__600">
                      {fileWarrningText}
                    </p>
                  )}
                  <p>{loading && "Processing"}</p>

                  <div className="form-row mt-3">
                    <div className="col-lg-5">
                      <button
                        className="btn sparkle--button__green px-5 mt-4 btn-block mb-0"
                        type="submit"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ShareholderModal
